<template>
  <div class="bg-white px-4 py-5 sm:p-4">
      <div class="text-xl font-bold" style="text-align: center;">
        "Egresos - Exitosos" Embargo N° Proceso: <b style="color: #0e9f6e;">{{ data.numero_proceso }}</b>
      </div>
  </div>
    
  <div class="bg-white px-3 py-4 sm:p-4" v-if="viewInternaSoporte == ''">
    <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
      <div  class="text-xl font-bold" v-if="tipo_soporte == 'egreso'">
        Constitución de Título - Egreso
      </div>
      <div  class="text-xl font-bold" v-else-if="tipo_soporte == 'ingreso'">
        Constitución de Título - Ingreso
      </div>
      <div class="text-xl font-bold" v-else>
        Valor Actual Embargo: <b style="color: #0e9f6e;"> {{ vueNumberFormat(saldo_actual, {})}}</b>
      </div>

      <button v-if="viewInterna == 'list'" type="button" @click="changeView('update')" class="flex items-center w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-3 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" style="white-space: nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Nuevo Egreso - Exitoso
      </button>

      <div class="flex gap-x-3 mt-3 sm:mt-0">
        <button @click="downloadGeneralReport()"
          class="px-4 py-2 text-white bg-blue-500 w-full sm:w-auto rounded-md hover:bg-blue-600 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="inline-block w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
          </svg>
          Descargar Consolidado
        </button>

        <button @click="viewInterna == 'list' ? handleButtonClick() : changeView('list');"
                class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
               stroke="currentColor" class="inline-block w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
          </svg>
          <span class="ml-3">Volver</span>
        </button>
      </div>

    </div>
    <slot></slot>
  </div>

  <div class="mt-6 overflow-x-auto" v-if="viewInterna == 'list'">
    <table class="w-full table-auto">
      <thead>
        <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">     
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            NúMERO Egreso
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
              Fecha Comprobante
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
              Fecha pago
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
              Banco
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
              cuenta bancaria
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
              nombre cuenta
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
              concepto
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
              valor
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
              Documento Soporte
          </th>
          <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
              Título Judicial
          </th>
        </tr>
      </thead>
      <tbody class="text-sm font-normal text-gray-700 text-center">
        <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(dataExitoso, indexCollectionData) of collectionData" :key="indexCollectionData">
          <td class="px-4 py-4">
            {{ dataExitoso.numero_egreso }}
          </td>
          <td class="px-4 py-4">
            {{ dataExitoso.fecha_comprobante }}
          </td>
          <td class="px-4 py-4">
            {{ dataExitoso.fecha_pago }}
          </td>
          <td class="px-4 py-4">
            {{ dataExitoso.cuentaBancaria.banco.nombre_banco }}
          </td>
          <td class="px-4 py-4">
            {{ dataExitoso.cuentaBancaria.cuenta_bancaria }}
          </td>
          <td class="px-4 py-4">
            {{ dataExitoso.cuentaBancaria.nombre_cuenta }}
          </td>
          <td class="px-4 py-4">
            {{ dataExitoso.concepto }}
          </td>
          <td class="px-4 py-4">
            {{ vueNumberFormat(dataExitoso.valor, {})}}
          </td>
          <td class="px-4 py-4">
              <button v-if="dataExitoso.soportes.length > 0"
                      @click="descargarDocumentoSoporte(dataExitoso.soportes[0].url_soporte)"
                      class="px-4 py-2 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                      stroke="currentColor" class="inline-block w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                  </svg>
                <span class="ml-3">Descargar documento de soporte</span>
              </button>
          </td>
          <td class="px-4 py-4 flex">
              <button v-if="!dataExitoso.estado" @click="enableDisableState(dataExitoso,'activar')"
                      class="items-center px-2 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5"/>
                </svg>
              </button>
              <button v-else @click="enableDisableState(dataExitoso,'desactivar')"
                      class="items-center px-2 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none"
                      style="margin-left: 10px;">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                </svg>
              </button>
              <template v-if="dataExitoso.soportesExitosos.length == 0">
                <button @click="changeViewSoporte('add_soporte_constitucion', dataExitoso, 'egreso')"
                  class="flex items-center px-2 py-1 text-white bg-green-500 rounded-md hover:bg-green-600 focus:outline-none"
                  style="margin-left: 10px;">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5"
                  style="margin-right: 5px;">
                    <path stroke-linecap="round" stroke-width="2" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Egreso
                </button>
                <button  @click="changeViewSoporte('add_soporte_constitucion', dataExitoso, 'ingreso')"
                  class="flex items-center px-2 py-1 text-white bg-green-500 rounded-md hover:bg-green-600 focus:outline-none"
                  style="margin-left: 10px;">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5"
                  style="margin-right: 5px;">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Ingreso
                </button>
              </template>            
              <template v-else v-for="(soporte, indexSoporte) of dataExitoso.soportesExitosos" :key="indexSoporte">
                <template  v-if="dataExitoso.soportesExitosos.length > 1">
                    <button v-if="soporte.tipo_constitucion  == 'egreso'"
                          @click="descargarDocumentoSoporteEgresoIngreso(soporte.url_soporte)"
                          class=" flex items-center px-2 py-1 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none"
                          style="margin-left: 10px;">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="inline-block w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                      </svg>
                      <span class="ml-3">Descargar Egreso</span>
                    </button>
                    <button v-if="soporte.tipo_constitucion  == 'ingreso'"
                        @click="descargarDocumentoSoporteEgresoIngreso(soporte.url_soporte)"
                        class=" flex items-center px-2 py-1 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none"
                        style="margin-left: 10px;">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="inline-block w-6 h-6" >
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                        </svg>
                      <span class="ml-3">Descargar Ingreso</span>
                    </button>
                </template>
                <template v-else>
                    <button v-if="soporte.tipo_constitucion  == 'egreso'"
                          @click="descargarDocumentoSoporteEgresoIngreso(soporte.url_soporte)"
                          class=" flex items-center px-2 py-1 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none"
                          style="margin-left: 10px;">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="inline-block w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                      </svg>
                      <span class="ml-3">Descargar Egreso</span>
                    </button>
                    <button v-else @click="changeViewSoporte('add_soporte_constitucion', dataExitoso, 'egreso')"
                      class="flex items-center px-2 py-1 text-white bg-green-500 rounded-md hover:bg-green-600 focus:outline-none"
                      style="margin-left: 10px;">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5"
                      style="margin-right: 5px;">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Egreso
                    </button>
                    <button v-if="soporte.tipo_constitucion  == 'ingreso'"
                        @click="descargarDocumentoSoporteEgresoIngreso(soporte.url_soporte)"
                        class=" flex items-center px-2 py-1 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none"
                        style="margin-left: 10px;">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="inline-block w-6 h-6">
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                        </svg>
                      <span class="ml-3">Descargar Ingreso</span>
                    </button>
                    <button  v-else @click="changeViewSoporte('add_soporte_constitucion', dataExitoso, 'ingreso')"
                      class="flex items-center px-2 py-1 text-white bg-green-500 rounded-md hover:bg-green-600 focus:outline-none"
                      style="margin-left: 10px;">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5"
                      style="margin-right: 5px;">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      Ingreso
                    </button>
                </template>
              </template>   
              
              <!-- Mostrar el botón de cargar soportes -->
              <button @click="changeViewSoporte('add_soportes', dataExitoso, '')"
                  class="flex items-center px-2 py-1 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none"
                  style="margin-left: 10px;">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5"
                style="margin-right: 5px;">
                  <path stroke-linecap="round" stroke-width="2" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Soportes
              </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="viewInterna == 'update'">
    <div class="bg-white px-4 py-5 sm:p-6" > 
      <div class="grid grid-cols-6 gap-6" > 
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion_demandante" class="block text-sm font-medium text-gray-700">Identificación Demandante</label>
          <input type="text" id="identificacion_demandante" v-model="identificacion_demandante"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion_demandante" class="block text-sm font-medium text-gray-700">Primer Nombre Demandante</label>
          <input type="text" id="identificacion_demandante" v-model="demandante.primer_nombre"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion_demandante" class="block text-sm font-medium text-gray-700">Segundo Nombre Demandante</label>
          <input type="text" id="identificacion_demandante" v-model="demandante.segundo_nombre"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion_demandante" class="block text-sm font-medium text-gray-700">Primer Apellido Demandante</label>
          <input type="text" id="identificacion_demandante" v-model="demandante.primer_apellido"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion_demandante" class="block text-sm font-medium text-gray-700">Segundo Apellido Demandante</label>
          <input type="text" id="identificacion_demandante" v-model="demandante.segundo_apellido"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion_demandado" class="block text-sm font-medium text-gray-700">Identificación Demandado</label>
          <input type="text" id="identificacion_demandado" v-model="identificacion_demandado"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion_demandado" class="block text-sm font-medium text-gray-700">Primer Nombre Demandado</label>
          <input type="text" id="identificacion_demandado" v-model="demandado.primer_nombre"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion_demandado" class="block text-sm font-medium text-gray-700">Segundo Nombre Demandado</label>
          <input type="text" id="identificacion_demandado" v-model="demandado.segundo_nombre"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion_demandado" class="block text-sm font-medium text-gray-700">Primer Apellido Demandado</label>
          <input type="text" id="identificacion_demandado" v-model="demandado.primer_apellido"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="identificacion_demandado" class="block text-sm font-medium text-gray-700">Segundo Apellido Demandado</label>
          <input type="text" id="identificacion_demandado" v-model="demandado.segundo_apellido"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="banco_id" class="block text-sm font-medium text-gray-700">Nombre del Banco</label>
          <select id="banco_id" v-model="id_banco"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  @change="loadCuentas()">
            <option value="" selected>Seleccione un banco...</option>
            <option v-for="(banco, index) of collectionBancos" :key="'B'+index" :value="banco.id">{{
                banco.nombre_banco
              }}
            </option>
          </select>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="banco_id" class="block text-sm font-medium text-gray-700">Cuenta Bancaria <span style="color: red">(*)</span></label>
          <select id="banco_id" v-model="cuenta_bancaria"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  @change="changeDataCuenta()">
            <option value="" selected>Seleccione una cuenta...</option>
            <option v-for="(cuenta, index) of collectionCuentas" :key="'B'+index" :value="cuenta">{{
                cuenta.cuenta_bancaria
              }}
            </option>
          </select>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="tipo_cuenta" class="block text-sm font-medium text-gray-700">Tipo de Cuenta</label>
          <input type="text" id="tipo_cuenta" v-model="tipo_cuenta"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"  style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="nombre_cuenta" class="block text-sm font-medium text-gray-700">Nombre de Cuenta</label>
          <input type="text" id="nombre_cuenta" v-model="nombre_cuenta"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"  style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="numero_egreso" class="block text-sm font-medium text-gray-700">Número Egreso  <span style="color: red">(*)</span></label>
          <input type="number" id="numero_egreso" v-model="numero_egreso"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_comprobante" class="block text-sm font-medium text-gray-700">Fecha de Comprobante <span style="color: red">(*)</span></label>
          <input type="date" id="fecha_comprobante" v-model="fecha_comprobante" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_pago" class="block text-sm font-medium text-gray-700">Fecha de Pago<span style="color: red">(*)</span></label>
          <input type="date" id="fecha_pago" v-model="fecha_pago" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="concepto" class="block text-sm font-medium text-gray-700">Concepto <span style="color: red">(*)</span></label>
          <textarea type="text" id="concepto" v-model="concepto"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"   />
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="valor" class="block text-sm font-medium text-gray-700">Valor <span style="color: red">(*)</span></label>
          <input v-model="valor" id="valor" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                 type="text"/>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label class="block text-sm mb-1 font-medium text-gray-700">Cargue de soporte </label>
          <div class="max-w-xl mb-3" id="cargue_archivo_embargos">
            <label style="min-height: 8rem;" for="archivo"
                  class="flex justify-center w-full transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
              <span ref="fileFormEnter" id="contenedor_archivo" class="flex items-center space-x-2 w-full">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-600 grow" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
                </svg>
                <span class="font-medium text-gray-600 grow">
                Arrastra el archivo aquí, o
                <span class="text-blue-600 underline">abre el explorador</span>
                </span>
              </span>
              <span ref="fileFormDrop" id="drag_over" class="hidden">
                <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600 grow"
                    fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
                </svg>
              </span>
              <span ref="fileFormUploaded" id="info_archivo" :class="documentoSoporte? 'font-bold block w-full flex flex-col justify-center align-middle gap-3 px-3' : 'hidden'">
                <img id="preview_archivo" src="" alt=""/>
                <span class="flex justify-center align-middle gap-3">
                  <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600"
                      fill="none"
                      viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"/>
                  </svg>
                  <span id="nombre_archivo" class="self-center"></span>
                </span>
              </span>
              <input type="file" id="archivo" class="hidden" @change="
                uploadFile(document.getElementById('archivo').files.item(0));
                documentoSoporte=document.getElementById('archivo').files.item(0); ">
            </label>
          </div>
        </div>
      </div>
    </div>


    <div id="btnUpdate" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
      <button type="button" @click="customSaveData()" class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        Guardar
      </button>
    </div>
  </div>

  <div v-if="viewInterna == 'add_soporte_constitucion'">
    <div class="bg-white px-4 py-5 sm:p-6" > 
      <div class="grid grid-cols-6 gap-6" > 
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="numero_exitoso" class="block text-sm font-medium text-gray-700">Número de Egreso</label>
          <input type="text" id="numero_exitoso" v-model="numero_exitoso"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_pago_soporte" class="block text-sm font-medium text-gray-700">Fecha de Pago</label>
          <input type="text" id="fecha_pago_soporte" v-model="fecha_pago_soporte"  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;" disabled>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label class="block text-sm mb-1 font-medium text-gray-700">Cargue de soporte {{ tipo_soporte.charAt(0).toUpperCase() + tipo_soporte.slice(1) }} </label>
          <div class="max-w-xl mb-3" id="cargue_archivo_embargos">
            <label style="min-height: 8rem;" for="archivo"
                  class="flex justify-center w-full transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
              <span ref="fileFormEnter" id="contenedor_archivo" class="flex items-center space-x-2 w-full">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-600 grow" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
                </svg>
                <span class="font-medium text-gray-600 grow">
                Arrastra el archivo aquí, o
                <span class="text-blue-600 underline">abre el explorador</span>
                </span>
              </span>
              <span ref="fileFormDrop" id="drag_over" class="hidden">
                <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600 grow"
                    fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
                </svg>
              </span>
              <span ref="fileFormUploaded" id="info_archivo" :class="documentoSoporte? 'font-bold block w-full flex flex-col justify-center align-middle gap-3 px-3' : 'hidden'">
                <img id="preview_archivo" src="" alt=""/>
                <span class="flex justify-center align-middle gap-3">
                  <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600"
                      fill="none"
                      viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"/>
                  </svg>
                  <span id="nombre_archivo" class="self-center"></span>
                </span>
              </span>
              <input type="file" id="archivo" class="hidden" @change="
                uploadFile(document.getElementById('archivo').files.item(0));
                documentoSoporte=document.getElementById('archivo').files.item(0); ">
            </label>
          </div>
        </div>
      </div>
    </div>
    <div id="btnUpdate" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
      <button type="button" @click="customSaveDataSoporte()" class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        Guardar
      </button>
    </div>
  </div>

  <div v-if="viewInterna == 'add_soportes'">

      <div class="bg-white px-3 py-4 sm:p-4">
        <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
          <div class="text-xl font-bold" >
            Valor Actual Embargo: <b style="color: #0e9f6e;"> {{ vueNumberFormat(saldo_actual, {})}}</b>
          </div>

          <button v-if="viewInternaSoporte == 'list'" type="button" @click="changeViewSoporteGeneral('update')" class="flex items-center w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-3 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" style="white-space: nowrap;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Nuevo Soporte
          </button>

          <button @click="viewInternaSoporte == 'list' ? changeView('list') : changeViewSoporteGeneral('list');"
                  class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="inline-block w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
            </svg>
            <span class="ml-3">Volver</span>
          </button>
        </div>
        <slot></slot>
      </div>

      <div class="mt-6 overflow-x-auto" v-if="viewInternaSoporte == 'list'">
        <table class="w-full table-auto">
          <thead>
          <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
            
            <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
              NúMERO 
            </th>
            <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
                Fecha
            </th>
            <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
                Nombre soporte
            </th>
            <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
                Documento Soporte
            </th>
            <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
                Opciones
            </th>
          </tr>
          </thead>
          <tbody class="text-sm font-normal text-gray-700 text-center">
            <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(dataSoporte, indexCollectionData) of collectionDataSoportes" :key="indexCollectionData">
              <td class="px-4 py-4">
                {{ dataSoporte.id }}
              </td>
              <td class="px-4 py-4">
                {{dateTime(dataSoporte.created_at)}}
              </td>
              <td class="px-4 py-4">
                {{ dataSoporte.nombre }}
              </td>
              <td class="px-4 py-4">
                  <button @click="descargarDocumentoSoporte(dataSoporte.url_soporte)"
                          class="px-4 py-2 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="inline-block w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                      </svg>
                    <span class="ml-3">Descargar documento de soporte</span>
                  </button>
              </td>
              <td class="px-4 py-4">
                  <button v-if="!dataSoporte.estado" @click="enableDisableStateSoportes(dataSoporte,'activar')"
                          class="items-center px-2 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                          stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5"/>
                    </svg>
                  </button>
                  <button v-else @click="enableDisableStateSoportes(dataSoporte,'desactivar')"
                          class="items-center px-2 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                          stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="viewInternaSoporte == 'update'">
        <div class="bg-white px-4 py-5 sm:p-6" > 
          <div class="grid grid-cols-6 gap-6" > 
            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label for="nombre" class="block text-sm font-medium text-gray-700">Nombre <span style="color: red">(*)</span></label>
              <input type="text" id="nombre" v-model="nombre" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
            </div>
            <div class="col-span-6 sm:col-span-3 lg:col-span-2">
              <label class="block text-sm mb-1 font-medium text-gray-700">Cargue de soporte <span style="color: red">(*)</span></label>
              <div class="max-w-xl mb-3" id="cargue_archivo_embargos">
                <label style="min-height: 8rem;" for="archivo"
                      class="flex justify-center w-full transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
                  <span ref="fileFormEnter" id="contenedor_archivo" class="flex items-center space-x-2 w-full">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-600 grow" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
                    </svg>
                    <span class="font-medium text-gray-600 grow">
                    Arrastra el archivo aquí, o
                    <span class="text-blue-600 underline">abre el explorador</span>
                    </span>
                  </span>
                  <span ref="fileFormDrop" id="drag_over" class="hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600 grow"
                        fill="none"
                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round"
                            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
                    </svg>
                  </span>
                  <span ref="fileFormUploaded" id="info_archivo" :class="documentoSoporte? 'font-bold block w-full flex flex-col justify-center align-middle gap-3 px-3' : 'hidden'">
                    <img id="preview_archivo" src="" alt=""/>
                    <span class="flex justify-center align-middle gap-3">
                      <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600"
                          fill="none"
                          viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"/>
                      </svg>
                      <span id="nombre_archivo" class="self-center"></span>
                    </span>
                  </span>
                  <input type="file" id="archivo" class="hidden" @change="
                    uploadFile(document.getElementById('archivo').files.item(0));
                    documentoSoporte=document.getElementById('archivo').files.item(0); ">
                </label>
              </div>
            </div>
          </div>
        </div>

        <div id="btnUpdate" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
          <button type="button" @click="customSaveData2()" class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            Guardar
          </button>
        </div>
      </div>
  </div>

</template>

<script>
import {saveUpdateData} from "@/layouts/main";
import {ref , watch, nextTick } from "vue";
import moment from 'moment';
import Swal from "sweetalert2";
import { uploadFile, useAPIRest, removeFile, swal, generateTextError, verifyHttpCode } from "@/common/constants"; 
import mime from "mime";
import { v4 as uuidv4 } from 'uuid';
import {listCollectionData, enableDisableData} from "@/layouts/main";
import { separateNumberByComma, separateNumberByCommaInput  } from "@/common/constants/functions";
import { utils, writeFile } from "xlsx-js-style";

export default {
  name: 'ExitososEmbargoPersonaComponent',
  props: ['data', 'entity', 'authToken'],
  emits: ["updateValues", "watchList"],
  async setup(props, { emit }) {
    const viewInterna = ref('list');    
    const identificacion_demandante = ref(props.data.demandante.identificacion)
    const demandante = ref(props.data.demandante)
    const identificacion_demandado = ref(props.data.demandado.identificacion)
    const demandado = ref(props.data.demandado)
    const documentoSoporte = ref('');
    const saldo_actual = ref(parseFloat(props.data.valor_actual));
    const numero_egreso = ref('');
    const fecha_comprobante = ref('');
    const concepto = ref('');
    const viewInternaSoporte = ref('');
    const documentoSoporte2 = ref('');
    const nombre = ref('');
    const collectionDataSoportes = ref([])

    const collectionData = ref([]);
    const collectionBancos = ref([]);
    const collectionCuentas = ref([]);
    
    const id_banco = ref('');
    const cuenta_bancaria = ref('');
    const nombre_cuenta = ref('');
    const tipo_cuenta = ref('');
    const fecha_pago = ref('');
    const valor = ref('');
    const numero_exitoso = ref('');
    const fecha_pago_soporte = ref('');
    const id_exitoso = ref('');
    const tipo_soporte = ref('');

    const changeView = (tipo_vista) => {
      viewInterna.value = tipo_vista
      tipo_soporte.value = ''
      viewInternaSoporte.value = '';

    }

    const changeViewSoporteGeneral = (tipo_vista) => {
      viewInternaSoporte.value = tipo_vista
    }

    const customSaveData = async () =>  {

        try {
          
          let dataSave = {
            id_embargo_persona : props.data.id,
            fecha_pago: fecha_pago.value,
            id_cuenta_bancaria: cuenta_bancaria.value.id,
            valor: valor.value.replaceAll(',', ''),
            numero_egreso: numero_egreso.value,
            fecha_comprobante: fecha_comprobante.value,
            concepto: concepto.value,
          }

          const nameCompletoFields = {
            fecha_pago: 'Fecha de pago',
            id_cuenta_bancaria: 'Cuenta bancaria ',
            valor: 'Valor',
            numero_egreso: 'Número Egreso',
            fecha_comprobante: 'Fecha Comprobante',
            concepto: 'Concepto ',
          }

          let error = '';
          for ( let key in nameCompletoFields){
            console.log('key',dataSave[key]);
            if(dataSave[key] == '' || dataSave[key] == undefined){
              error += `El campo ${ nameCompletoFields[key] } es obligatorio. <br>`;
            }
          }

          if(error != ''){
            Swal.fire({
              title: error,
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
            return;
          }

          if (parseFloat(valor.value.replaceAll(',', '')) < 0) {
            Swal.fire({
                title: 'Error',
                icon: 'error',
                text: 'El valor no puede ser negativo.',
                showCloseButton: true,
                focusConfirm: false,
              })
              return;
          } 

          if(props.data.demandado.tipoPersona.nombre != 'Contratista'){
            if(saldo_actual.value < valor.value.replaceAll(',', '')){
              Swal.fire({
                title: 'Error',
                icon: 'error',
                text: 'El valor no puede ser superior al saldo actual.',
                showCloseButton: true,
                focusConfirm: false,
              })
              return;
            }
          }

          let listApi = {
            create: process.env.VUE_APP_NEST_EMBARGOPERSONA_CREATE_EXITOSO,
            list: process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_EXITOSO,
          };


          const newLoadData = new FormData();
          let validDocumentoSoporte = false;

          /**
           Valida el tamaño del archivo de soporte y lo agrega al FormData si es válido.
          */
          
          if (documentoSoporte.value) {
            const pesoMaximo = 10 * 1024 * 1024;
            if (documentoSoporte.value.size > pesoMaximo) {
              validDocumentoSoporte = false;
              removeFile(document.getElementById('cargue_archivo_embargos'));
              documentoSoporte.value = undefined;
              await swal.fire('¡El archivo excede el tamaño de 10MB maximo permitido!', '', 'error');
              return;
            } else{

              validDocumentoSoporte = true;
              const uniqueFilename = `${uuidv4()}-${documentoSoporte.value.name}`;
              newLoadData.append('file', documentoSoporte.value, uniqueFilename);
            }
          }

          const resJSON = await saveUpdateData({
            listApi,
            authToken: props.authToken,
            loadData: dataSave,
            action:'crear',
            entity: props.entity,
            view:'crear',
          }, undefined, false, false, true);

          
          if(resJSON.statusCode == 200 || resJSON.statusCode == 201){
            

            listApi = {
              create: process.env.VUE_APP_NEST_EMBARGOPERSONA_CREATE_SOPORTE_EXITOSO,
              list: process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_EXITOSO,
            };
            
            newLoadData.append('id_exitosos_embargos_personas', resJSON.id);            
            
            if (validDocumentoSoporte){              
              await saveUpdateData({
                listApi,
                authToken: props.authToken,
                loadData: newLoadData,
                action: 'crear',
                entity: props.entity,
                view: 'crear',
                options: {
                  save: {
                    contentType: 'auto'
                  },
                  update: {
                    contentType: 'auto'
                  }
                }
              }, emit, true, false, true);
            }

            id_banco.value = '';
            cuenta_bancaria.value = '';
            nombre_cuenta.value = '';
            tipo_cuenta.value = '';
            fecha_pago.value = '';
            numero_egreso.value = '';
            fecha_comprobante.value = '';
            concepto.value = '';
            collectionCuentas.value = [];

            if(props.data.demandado.tipoPersona.nombre != 'Contratista'){              
              if((saldo_actual.value - valor.value.replaceAll(',', '')) <= 0){
                saldo_actual.value = 0;
              }else{
                saldo_actual.value -= valor.value.replaceAll(',', '');
              }
            }
            
            valor.value = '';
            validDocumentoSoporte   = false;
            removeFile(document.getElementById('cargue_archivo_embargos'));
            documentoSoporte.value  = undefined;
            viewInterna.value       = 'list'

          }

          listData();

        }catch (error) {
          Swal.fire({
              title: 'Error al guardar',
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
          console.error('Error al guardar:', error);
        }
    }

    const listData = async () => await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_EXITOSO.replace(':id', props.data.id), 'GET', props.authToken, undefined, undefined, 'application/json')
      .then(res => {
          collectionData.value = res;
      });
    
    listData();

    const handleButtonClick = () => {
        emit('updateValues', { view: 'listar' });
        emit('watchList', { parametro: 'valor' });
    }

    const enableDisableState = async (data, tipo)  => {

      const listApi = {
                        updateState: process.env.VUE_APP_NEST_EMBARGOPERSONA_UPDATESTATE_EXITOSO
                      };


      let estadoData = data.estado;
      await enableDisableData(props.entity, tipo, data, listApi['updateState'],  props.authToken)

      if(props.data.demandado.tipoPersona.nombre != 'Contratista'){   

        let valorRedondeado = Math.round(saldo_actual.value);
        let valorRedondeadoEmbargo = Math.round(data.valor);

        if(estadoData)
        {
          saldo_actual.value = valorRedondeado + valorRedondeadoEmbargo;
        }else{
          let resta = valorRedondeado - valorRedondeadoEmbargo;

          if(resta >= 0){
            saldo_actual.value = valorRedondeado - valorRedondeadoEmbargo;
          }
        }

      }

      listData();
    }

    const listBancos = async () => await listCollectionData(process.env.VUE_APP_NEST_BANCO_FINDALL, {'collectionBancos': collectionBancos}, props.authToken, undefined, undefined, undefined, undefined, undefined, undefined, false);

    listBancos();

    const loadCuentas = async ()  => { 

      if(id_banco.value != ''){
        await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_CUENTA_BANCARIA.replace(':id', id_banco.value), 'GET', props.authToken, undefined, undefined, 'application/json')
        .then(res => {
                collectionCuentas.value = res;
        });
      }else{
        collectionCuentas.value = [];
        cuenta_bancaria.value   = ''
      }
    }

    const changeDataCuenta = () => {

      nombre_cuenta.value = cuenta_bancaria.value.nombre_cuenta;
      tipo_cuenta.value = cuenta_bancaria.value.tipo_cuenta;
    }

    const changeViewSoporte = (tipo_vista, dataExitoso, tipo) => {
      viewInterna.value = tipo_vista;
      fecha_pago_soporte.value = dataExitoso.fecha_pago;
      numero_exitoso.value = dataExitoso.numero_egreso;
      id_exitoso.value = dataExitoso.id;
      tipo_soporte.value = tipo;

      if(tipo_vista == 'add_soportes'){
        viewInternaSoporte.value = 'list';
        id_exitoso.value =   dataExitoso.id;
        listDataSoportes();
      }else{
        viewInternaSoporte.value = '';

      }
    }

    const customSaveDataSoporte = async () => {
      try {

          const newLoadData = new FormData();
          let validDocumentoSoporte = false;

          /**
           Valida el tamaño del archivo de soporte y lo agrega al FormData si es válido.
          */
          
          if (documentoSoporte.value) {
            const pesoMaximo = 10 * 1024 * 1024;
            if (documentoSoporte.value.size > pesoMaximo) {
              validDocumentoSoporte = false;
              removeFile(document.getElementById('cargue_archivo_embargos'));
              documentoSoporte.value = undefined;
              await swal.fire('¡El archivo excede el tamaño de 10MB maximo permitido!', '', 'error');
              return;
            } else{

              validDocumentoSoporte = true;
              const uniqueFilename = `${uuidv4()}-${documentoSoporte.value.name}`;
              newLoadData.append('file', documentoSoporte.value, uniqueFilename);
            }
          }else{
              Swal.fire({
                title: 'Documento Egreso es Obligatorio',
                icon: 'error',
                showCloseButton: true,
                focusConfirm: false,
              })
              return;
          }

          const listApi = {
            create: process.env.VUE_APP_NEST_EMBARGOPERSONA_CREATE_SOPORTE_EGRESOINGRESO,
            list: process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_EXITOSO,
          };
          
          newLoadData.append('id_exitoso_embargo_persona', id_exitoso.value);            
          newLoadData.append('tipo_constitucion', tipo_soporte.value);            
            
          if (validDocumentoSoporte){              
            await saveUpdateData({
              listApi,
              authToken: props.authToken,
              loadData: newLoadData,
              action: 'crear',
              entity: { gender: 'f', value: 'Constitución de Título' },
              view: 'crear',
              options: {
                save: {
                  contentType: 'auto'
                },
                update: {
                  contentType: 'auto'
                }
              }
            }, undefined, false, false, true);
          }

          fecha_pago_soporte.value = '';
          numero_exitoso.value = '';
          id_exitoso.value = '';
          tipo_soporte.value  = '';
          validDocumentoSoporte   = false;
          removeFile(document.getElementById('cargue_archivo_embargos'));
          documentoSoporte.value  = undefined;
          viewInterna.value       = 'list'

          listData();

        }catch (error) {
          Swal.fire({
              title: 'Error al guardar',
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
          console.error('Error al guardar:', error);
        }
    }

    watch(() => valor.value, (newSaldoInicial) => {
        nextTick(() => valor.value = separateNumberByCommaInput(newSaldoInicial));
      })


    const customSaveData2 = async () =>  {
      try {
        console.log('id_exitoso.value',id_exitoso.value);
        let dataSave = {
          id_exitoso_embargo_persona : id_exitoso.value,
          nombre: nombre.value,
        }

        const nameCompletoFields = {
          nombre: 'nombre '
        }

        let error = '';
        for ( let key in nameCompletoFields){
          console.log('key',dataSave[key]);
          if(dataSave[key] == ''){
            error += `El campo ${ nameCompletoFields[key] } es obligatorio. <br>`;
          }
        }

        if(error != ''){
          Swal.fire({
            title: error,
            icon: 'error',
            showCloseButton: true,
            focusConfirm: false,
          })
          return;
        }


        const newLoadData = new FormData();
        let validDocumentoSoporte = false;

        /**
         Valida el tamaño del archivo de soporte y lo agrega al FormData si es válido.
        */
        
        if (documentoSoporte.value) {
          const pesoMaximo = 10 * 1024 * 1024;
          if (documentoSoporte.value.size > pesoMaximo) {
            validDocumentoSoporte = false;
            removeFile(document.getElementById('cargue_archivo_embargos'));
            documentoSoporte.value = undefined;
            await swal.fire('¡El archivo excede el tamaño de 10MB maximo permitido!', '', 'error');
            return;
          } else{

            validDocumentoSoporte = true;
            const uniqueFilename = `${uuidv4()}-${documentoSoporte.value.name}`;
            newLoadData.append('file', documentoSoporte.value, uniqueFilename);
          }
        }else{
            Swal.fire({
              title: 'Documento soporte es requerido.',
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
            return;
        }

        const listApi = {
          create: process.env.VUE_APP_NEST_EMBARGOPERSONA_CREATE_SOPORTE_EXITOSOS,
          list: process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_SOPORTE_EXITOSOS,
        };
        
        newLoadData.append('id_exitoso_embargo_persona', id_exitoso.value);   
        newLoadData.append('nombre', nombre.value);            

        
        if (validDocumentoSoporte){              
          await saveUpdateData({
            listApi,
            authToken: props.authToken,
            loadData: newLoadData,
            action: 'crear',
            entity: props.entity,
            view: 'crear',
            options: {
              save: {
                contentType: 'auto'
              },
              update: {
                contentType: 'auto'
              }
            }
          }, undefined, false, false, true);
        }

        nombre.value            = '';
        validDocumentoSoporte   = false;
        removeFile(document.getElementById('cargue_archivo_embargos'));
        documentoSoporte.value  = undefined;
        viewInternaSoporte.value       = 'list'
        
        listDataSoportes();

      }catch (error) {
        Swal.fire({
            title: 'Error al guardar',
            icon: 'error',
            showCloseButton: true,
            focusConfirm: false,
          })
        console.error('Error al guardar:', error);
      }
    }

    const listDataSoportes = async () => await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_SOPORTE_EXITOSOS.replace(':id', id_exitoso.value), 'GET', props.authToken, undefined, undefined, 'application/json')
      .then(res => {
          collectionDataSoportes.value = res;
      });
      
    const enableDisableStateSoportes = async (data, tipo)  => {

      const listApi = {
                        updateState: process.env.VUE_APP_NEST_EMBARGOPERSONA_UPDATESTATE_SOPORTE_EXITOSOS
                      };

      await enableDisableData(props.entity, tipo, data, listApi['updateState'],  props.authToken)

      listDataSoportes();
    }

    const downloadGeneralReport = async () => {
      await useAPIRest(process.env.VUE_APP_NEST_EMBARGO_PERSONA_EXPORT_EGRESOS.replace(':id',props.data.id),'GET',props.authToken, undefined, undefined, 'application/json')
        .then(res => {
          const wb = utils.book_new();
          let content = []
          let headers = [
            [
              { v: "NÚMERO EGRESO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "FECHA COMPROBANTE", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "FECHA PAGO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "BANCO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "CUENTA BANCARIA", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "NOMBRE CUENTA", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "CONCEPTO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "VALOR", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "ESTADO EGRESO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
            ],
          ]
            res.forEach(element => {
              content = [ ...content,
                [
                  { v: element.numero_egreso, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.created_at.split('T')[0], t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.fecha_pago, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.cuentaBancaria.banco.nombre_banco, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.cuentaBancaria.cuenta_bancaria, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.cuentaBancaria.nombre_cuenta, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.concepto, t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: separateNumberByComma(element.valor), t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.estado ? 'ACTIVO' : 'INACTIVO', t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                ],
              ];
            });
          const excel = headers.concat(content)
          
          const ws = utils.aoa_to_sheet(excel);

          ws['!cols'] = Array(headers[0].length).fill({ wch: 40 });

          utils.book_append_sheet(wb, ws, 'EGRESOS');

          writeFile(wb, `Información_egresos_embargo_${res[0].embargos.numero_proceso}.xlsx`);
        });
    }


    return {
      changeView,
      viewInterna,
      valor,
      identificacion_demandante,
      demandante,
      identificacion_demandado,
      demandado,
      customSaveData,
      collectionData,
      listData,
      handleButtonClick,
      documentoSoporte,
      document: document,
      uploadFile : uploadFile,
      enableDisableState,
      collectionBancos,
      collectionCuentas,
      changeDataCuenta,
      loadCuentas,
      id_banco,
      cuenta_bancaria,
      nombre_cuenta,
      tipo_cuenta,
      fecha_pago,
      changeViewSoporte,
      fecha_pago_soporte,
      numero_exitoso,
      customSaveDataSoporte,
      tipo_soporte,
      saldo_actual,
      numero_egreso,
      fecha_comprobante,
      concepto,
      viewInternaSoporte,
      changeViewSoporteGeneral,
      nombre,
      documentoSoporte2,
      customSaveData2,
      collectionDataSoportes,
      enableDisableStateSoportes,
      id_exitoso,
      downloadGeneralReport,
    }
  },
  methods: {
    dateTime(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm');
    },
    async descargarDocumentoSoporte(fileName) {
        await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_OBTENERARCHIVO_EXITOSO, 'GET', this.authToken, undefined, {
          'url': fileName
        }).then(async resJSON => {
          const {statusCode} = resJSON;
          delete resJSON.statusCode;
          const textoError = generateTextError(resJSON);
          if (verifyHttpCode(statusCode, 'success')) {
            const blob = await resJSON.blob();
            const newBlob = new Blob([blob], {type: mime.getType(fileName)});
            const url = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName.replace('src/assets/documentos_soporte_embargos/personas/', ''));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else await swal.fire(textoError, '', 'error');
        });
    },
    async descargarDocumentoSoporteEgresoIngreso(fileName) {
      await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_OBTENERARCHIVO_EGRESOINGRESO, 'GET', this.authToken, undefined, {
        'url': fileName
      }).then(async resJSON => {
        const {statusCode} = resJSON;
        delete resJSON.statusCode;
        const textoError = generateTextError(resJSON);
        if (verifyHttpCode(statusCode, 'success')) {
          const blob = await resJSON.blob();
          const newBlob = new Blob([blob], {type: mime.getType(fileName)});
          const url = window.URL.createObjectURL(newBlob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName.replace('src/assets/documentos_soporte_embargos/personas/', ''));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else await swal.fire(textoError, '', 'error');
      });
    },
  },
  watch: {
    "documentoSoporte": function (documentoSoporte) {
      if (documentoSoporte) {
        if (window.navigator.userAgent.includes("Firefox")) {
          const name = documentoSoporte.name;
          const mimeType = documentoSoporte.type;
          const lastDot = name.lastIndexOf('.');
          const fileName = name.substring(0, lastDot);
          const ext = name.substring(lastDot + 1);
          if (ext === 'csv' && mimeType !== 'text/csv') this.documentoSoporte = new File([documentoSoporte], `${fileName}.${ext}`, {type: 'text/csv'});
        }
      }
    },
  },
}

</script>